import { MantineProvider } from '@mantine/core';

export const LightThemeProvider = ({ children }: { children: React.ReactNode }) => (
    <MantineProvider theme={{ colorScheme: 'light' }} inherit>
        {children}
    </MantineProvider>
);
